import React from "react";
import {HomeOutlined, TeamOutlined, TagOutlined} from '@ant-design/icons';
import {IGroupEntry} from "@Components/groups/GroupUtils";
import {Avatar} from "antd";

interface IProps {
    group: IGroupEntry;
    level: number;
    handleGroupSelect: (groupEntry: IGroupEntry) => void;
}

const GroupListGroupItem: React.FC<IProps> = ( { group, level, handleGroupSelect }: IProps) => {
    const license = group?.capacity > -1;
    return (
        <div
            id={"group-item-l-"+level+"-g-"+group.groupId}
            key={"group-item-"+group.groupId} 
            className={
                license ? "groups-list-list-item groups-list-group-item license" : "groups-list-list-item groups-list-group-item"
            }
        >
            <table>
                <tbody>
                    <tr
                        onClick={() => handleGroupSelect(group)}
                        className={"groups-list-group-item-row"}
                    >
                        <td>
                            <Avatar
                                size="small"
                                className={"group-icon group-item-icon"}
                                style={{ marginRight: 10 }}
                                icon={level == -1 ? <HomeOutlined /> : (!license ? <TeamOutlined /> : <TagOutlined />)}
                            />
                            {group.name}
                        </td>
                        <td style={{width: "110px", textAlign: "right"}}>
                            <div >
                                <TeamOutlined size={10} style={{color: "rgba(255,255,255,0.6)"}}/> 
                                <Avatar
                                    size="small"
                                    className={"group-icon group-item-icon"}
                                    icon={<>{group.count.toString()}</>}
                                />
                                {
                                    group.capacity > 0 &&
                                    <>
                                        &nbsp;/&nbsp;
                                        <Avatar
                                            size="small"
                                            className={"group-icon group-item-icon"}
                                            icon={<>{group.capacity.toString()}</>}
                                        />
                                    </>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>  
    );
};
export default GroupListGroupItem;